import { render, staticRenderFns } from "./AIR.vue?vue&type=template&id=44536c53"
import script from "./AIR.vue?vue&type=script&lang=js"
export * from "./AIR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports